import type { JSX } from 'react'
import type { ISkeletonUnitProps } from '../../SkeletonUnit'

import { breakpointsWidthProgramCard } from 'blocks/Skeletons/components/SkeletonUnit/Templates/EPG/breakpoints'
import { getValueForBreakpoint } from 'utils/helpers'
import { useClientWidth } from 'utils/hooks'
import { SkeletonUnit } from '../../SkeletonUnit'
import { SkeletonUnitMargins } from '../../SkeletonUnit.h'

export interface IChannelProgramRowSkeletonUnitProps extends ISkeletonUnitProps {
  breakpointsWidth?: {}
}

export const ChannelProgramRowSkeletonUnit = ({
  height = '84px',
  margins = SkeletonUnitMargins.SIZE_30,
  breakpointsWidth = breakpointsWidthProgramCard,
  ...rest
}: IChannelProgramRowSkeletonUnitProps): JSX.Element => {
  const clientWidth = useClientWidth()
  const validWidth = breakpointsWidth
    ? getValueForBreakpoint(clientWidth, breakpointsWidth)
    : rest.width

  return (
    <SkeletonUnit height={height} margins={margins} {...rest}>
      <SkeletonUnit width={validWidth} margins={SkeletonUnitMargins.SIZE_60} />
      <SkeletonUnit flexGrow={'1'} />
    </SkeletonUnit>
  )
}
